// extracted by mini-css-extract-plugin
export default {"point":"XTzREdMBjyRRHGES7dUU"};